// @flow
import * as React from 'react';

const { useEffect, useState, useCallback } = React;

type ViewportSize = [number, number];

const ViewportContext = React.createContext<ViewportSize>([0, 0]);

export default ViewportContext;

export const ViewportContextProvider = ({
  children
}: {
  children: React.Node
}) => {
  const [viewportSize, setViewportSize] = useState([0, 0]);

  const handleResize = useCallback(() => {
    window.requestAnimationFrame(() => {
      setViewportSize([window.innerWidth, window.innerHeight]);
    });
  }, []);

  useEffect(
    () => {
      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    },
    [handleResize]
  );
  return (
    <ViewportContext.Provider value={viewportSize}>
      {children}
    </ViewportContext.Provider>
  );
};
